import { createBuilderModule } from '../../builder';
import { YouTubeVideo } from './YouTubeVideo';

export default createBuilderModule(YouTubeVideo, {
  name: 'youtubeVideo',
  image: 'https://cdn.zappy.app/6743fdc6e7c496290dc316ef1c5f2b28.png',
  inputs: [
    {
      name: 'youtubeId',
      type: 'string',
      defaultValue: 'QEmNOlXf-HY',
    },
    {
      name: 'title',
      type: 'string',
      defaultValue: 'Title for YouTube video',
    },
    {
      name: 'allowFullscreen',
      type: 'boolean',
      defaultValue: true,
    },
    {
      name: 'aspectRatio',
      type: 'number',
      defaultValue: 16 / 9,
    },
    {
      name: 'autoplay',
      type: 'boolean',
      defaultValue: false,
    },
  ],
});
